import axios from "axios";
import jsFileDownload from 'js-file-download';

export const $downloadFile = (url: string, filename: string = ''): Promise<boolean> => axios
	.get(url, { responseType: 'blob' })
	.then(r => {
		if (!r || !r.data) return false;

		return new Promise(resolve => {
			jsFileDownload(r.data, filename || String(Date.now()));

			setTimeout(() => resolve(true));
		});
	});